import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import { OptionBoxPopupFooter } from 'Components/OptionBoxPopup';
import './OptionBoxPopup.scss';

class OptionBoxPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      acquirerCode: JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
    };

    this.attachBindings();
  }


  attachBindings() {
    this.applyChanges = this.applyChanges.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  handleClickOutside(event) {
    if (!event.target.classList.contains("button-small") || !event.target.classList.contains("button-link") || !event.target.classList.contains("button")) {
      this.props.setScroll(0);
    }
    this.setState({
      isOpen: false,
    });
  }

  handleClick() {
    this.setState({
      isOpen: false,
    });
  }

  toggle() {
    if (this.state.isOpen === false && this.props.isMerchatActions) {
      this.props.getActionsList();
    }

    if (this.props.rowLength !== undefined) {
      if (this.props.rowLength == this.props.rowIndex + 1) {
        this.props.setScroll(4);
      }
      if (this.props.rowLength - this.props.rowIndex == 2) {
        this.props.setScroll(this.props.children.length - 1);
      }
    }
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }), () => {
      if (this.state.isOpen === false) {
        this.props.closeAction();
      }
    });

    if (this.props.rowLength !== undefined) {
      if (this.props.rowLength == this.props.rowIndex + 1 || this.props.rowLength - this.props.rowIndex == 2) {
        if (this.state.isOpen !== false) {
          this.props.setScroll(0);
        }
      }
    }

  }

  componentWillReceiveProps(newProps) {
    if (this.props.reportName == 'MRE') {
      if (this.props.isActionClick === undefined || this.props.isActionClick) {
        this.setState({
          isOpen: false
        })
      }
    } else {
      if (newProps.error) {
        this.setState({ isOpen: true });
      }
      if (this.props.isOpen !== undefined && newProps.isOpen) {
        this.setState({
          isOpen: newProps.isOpen,
        })
      }
    }
  }




  cancelChanges() {
    if (this.props.cancelAction) {
      this.props.cancelAction();
    }
    if (!this.props.keepOpenOnCancel) {
      this.toggle();
    }
  }

  applyChanges() {
    this.props.applyAction();
    this.toggle();
  }

  get optionButton() {
    const { borderVisible, translations } = this.props;
    const isDisabled = false; // @todo, change to prop
    let boxclass = this.props.isButtonCompact ? 'dropdown-menu-trigger-compact -' : 'dropdown-menu-trigger -'
    let acquirerCode=JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    const boxTriggerClasses = classnames(boxclass+' -'+this.state.acquirerCode,boxclass+'_'+acquirerCode, {
      'is-disabled': isDisabled,
      'show-border': borderVisible,
      'hide-border': !borderVisible,
    });
    
    return (  
      <div
        id={`${this.props.id}_btn_${this.props.triggerText}`}
        role="button"
        tabIndex={0}
        className={boxTriggerClasses}
        disabled={isDisabled}
        onClick={this.toggle}
        aria-expanded={this.state.isOpen}
      >
        {this.props.emphasizedTriggerText
          ? (
            <span id={this.props.id} className={"option-box-trigger-content " + this.state.acquirerCode + " selector -trigger_" + acquirerCode}>
              {this.props.icon()}
              <span className="option-box-trigger-emphasized">{this.props.emphasizedTriggerText}</span>
              {this.props.triggerText}
            </span>
          )
          : (
            <span id={this.props.id} className={"option-box-trigger-content " + this.state.acquirerCode + " selector -trigger_" + acquirerCode} style={this.props.reportName == "MRE" ? { fontSize: "20px", marginTop: "-12px" } : {}}>
              {this.props.icon()}
              {this.props.triggerText}
            </span>
          )
        }
      </div>
    );
  }

  render() {
    const { borderVisible, translations } = this.props;

    const wrapperClass = classnames('option-box-popup', {
      [this.props.extraClass]: this.props.extraClass,
      'inline-btn': this.props.emphasizedTriggerText,
      'icon-only': !this.props.triggerText,
    });

    const contentClasses = classnames('option-box-content', {
      'option-box-content--right': this.props.right,
      'option-box-content--center': this.props.center,
      'option-box-content last-five-row': this.props.rowIndex !== -1 && this.props.rowLength >= 4 && this.props.rowIndex >= ((this.props.rowLength - 4) === 0 ? 3 : (this.props.rowLength - 2)),
      'option-box-content only-first-four': this.props.rowIndex !== -1 && this.props.rowLength < 4, 
    });
    const optionalFooter = (this.props.hideFooterOverride === true) ? false :
      this.props.applyAction || this.props.cancelAction;
    const applyActionText = this.props.applyActionText !== '' ? this.props.applyActionText : translations.apply;
    return (
      <div
        id="option-box-wrapper"
        className={wrapperClass}
      >
        <OutsideClickHandler onClickOutside={this.handleClickOutside}>
          {!this.props.showHelpText && this.optionButton}

          {this.props.showHelpText && (
            <InformationBubble
              tooltipContent={this.props.showHelpText}
              id={`${this.props.id}_helptext`}
              place={'bottom'}
            >
              {this.optionButton}
            </InformationBubble>
          )}

          {this.state.isOpen && <div style={this.props.openBoxDropDownStyle} className={contentClasses} >
            {this.props.children}
            {optionalFooter && (
              <OptionBoxPopupFooter
                applyDisabled={this.props.applyDisabled}
                applyText={applyActionText}
                cancelText={translations.cancel}
                id={this.props.id}
                onApply={this.applyChanges}
                onCancel={this.cancelChanges}
                extraClass={this.state.acquirerCode}
              />
            )}
          </div>}
          {(this.props.onCloseClick === true) && (
            this.handleClick()
          )}
        </OutsideClickHandler>
      </div>
    );
  }
}

OptionBoxPopup.propTypes = {
  applyAction: PropTypes.func,
  applyDisabled: PropTypes.bool,
  cancelAction: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  extraClass: PropTypes.string,
  icon: PropTypes.func,
  id: PropTypes.string,
  translations: PropTypes.object,
  triggerText: PropTypes.string,
  emphasizedTriggerText: PropTypes.string,
  right: PropTypes.bool,
  center: PropTypes.bool,
  closeAction: PropTypes.func,
  hideFooterOverride: PropTypes.bool,
  applyActionText: PropTypes.string,
  keepOpenOnCancel: PropTypes.bool,
  borderVisible: PropTypes.bool,
  showHelpText: PropTypes.string,
  setScroll: PropTypes.func,
  onCloseClick: PropTypes.bool,
  reportName: PropTypes.string,
  isActionClick: PropTypes.bool,
};

OptionBoxPopup.defaultProps = {
  applyAction: null,
  children: [],
  applyDisabled: false,
  cancelAction: null,
  extraClass: '',
  icon: () => { },
  id: '',
  emphasizedTriggerText: '',
  translations: {
    cancel: 'Cancel',
    apply: 'Apply',
  },
  triggerText: '',
  right: false,
  center: false,
  closeAction: () => { },
  hideFooterOverride: false,
  applyActionText: '',
  keepOpenOnCancel: false,
  borderVisible: true,
  error: false,
  openBoxDropDownStyle: {},
  setScroll: () => { },
  onCloseClick: false,
  reportName: '',
};

export default OptionBoxPopup;
